export default __webpack_public_path__ + "static/media/ISBSession.8b3a63ae.JPG";